
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Step } from './index.vue';

@Component
export default class Content extends Vue {
  @Prop({ required: true }) steps!: Step[];
}
